const INELIGIBILITY_REASONS = {
  AGE: 'ineligible_age',
  ALREADY_COMPLETED_SIGN_UP: 'already_completed_sign_up',
  HAIR_AGE: 'ineligible_hair_age',
  STATE: 'ineligible_state',
  OBGYN: 'ineligible_obgyn',
  HAIR_CANNOT_RECEIVE_PRODUCT: 'ineligible_hair_cannot_receive_product',
  HAIR_LOSS_LOCATION: 'ineligible_hair_loss_location',
  HAIR_UNDELIVERABLE_ADDRESS: 'ineligible_hair_undeliverable_address',
  SHOULD_SHOW_NEW_SIGNUP_FLOW: 'should_show_new_signup_flow',
  UNKNOWN: 'unknown',
  NONE: 'none',
} as const;

export { INELIGIBILITY_REASONS };
